import React from 'react';
import { ServiceProvider } from './src/context/ServiceContext';
import "./src/styles/global.css"

export const wrapRootElement = ({ element }) => {
    return (
        <ServiceProvider>
            {process.env.IS_UNDER_MAINTENANCE === "TRUE" ? element : (
                <main className="h-screen w-screen bg-header flex flex-col items-center justify-center">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ height: 220, width: 220, color: "#D2B471" }}>
                        <path fillRule="evenodd" d="M9.401 3.003c1.155-2 4.043-2 5.197 0l7.355 12.748c1.154 2-.29 4.5-2.599 4.5H4.645c-2.309 0-3.752-2.5-2.598-4.5L9.4 3.003ZM12 8.25a.75.75 0 0 1 .75.75v3.75a.75.75 0 0 1-1.5 0V9a.75.75 0 0 1 .75-.75Zm0 8.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z" clipRule="evenodd" />
                    </svg>
                    <div className="text-center text-4xl font-bold mb-4">
                        We are Under Maintenance
                    </div>
                    <div className="text-center text-xl">
                        We will be back soon!
                    </div>
                </main>
            )}
        </ServiceProvider>
    );
};